import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Contact.css';
import AdmissionDropdown from '../components/AdmissionDropdown';

const cards = [
  {
    image: '/images/register-card.jpg',
    title: 'Registration Form',
    description: 'Apply for admission to any of our programs for the academic year 2026–27. Join a legacy of academic excellence that has been shaping students since 1966.',
    btnLabel: 'Register Now',
    dropdown: true,
    imageLeft: true,
  },
  {
    image: '/images/parent-login-card.jpg',
    title: 'Parent Login',
    description: 'Access your child\'s academic records, attendance, progress reports, and school updates — all in one place through our secure parent portal.',
    btnLabel: 'Login',
    btnHref: 'https://parent.opus-svect.com/Login',
    external: true,
    imageLeft: false,
  },
  {
    image: '/images/faqs-card.jpg',
    title: 'Frequently Asked Questions',
    description: 'Find answers to common questions about admissions, fees, curriculum, campus facilities, and more. We\'re here to help at every step.',
    btnLabel: 'View FAQs',
    btnHref: '/faq',
    external: false,
    imageLeft: true,
  },
];

const Contact = () => {
  return (
    <div className="contact-page">
      {cards.map((card, i) => (
        <section
          key={i}
          className={`rl-section ${card.imageLeft ? 'image-left' : 'image-right'}`}
        >
          <motion.div
            className="rl-section-image"
            initial={{ opacity: 0, x: card.imageLeft ? -40 : 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <img src={card.image} alt={card.title} />
          </motion.div>

          <motion.div
            className="rl-section-content"
            initial={{ opacity: 0, x: card.imageLeft ? 40 : -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <span className="rl-section-number">0{i + 1}</span>
            <h2>{card.title}</h2>
            <p>{card.description}</p>
            {card.dropdown ? (
              <AdmissionDropdown
                label={card.btnLabel}
                className="rl-btn"
                align="left"
              />
            ) : card.external ? (
              <a
                href={card.btnHref}
                target="_blank"
                rel="noopener noreferrer"
                className="rl-btn"
              >
                {card.btnLabel}
              </a>
            ) : (
              <Link to={card.btnHref} className="rl-btn">
                {card.btnLabel}
              </Link>
            )}
          </motion.div>
        </section>
      ))}
    </div>
  );
};

export default Contact;
